import { render, staticRenderFns } from "./DraftOpportunitiesDatatable.vue?vue&type=template&id=f52d9bea&scoped=true&"
import script from "./DraftOpportunitiesDatatable.vue?vue&type=script&lang=js&"
export * from "./DraftOpportunitiesDatatable.vue?vue&type=script&lang=js&"
import style0 from "./DraftOpportunitiesDatatable.vue?vue&type=style&index=0&id=f52d9bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52d9bea",
  null
  
)

export default component.exports